<template>
  <div class="app">
    <AppHeader />
    <div class="app-body">
      <Sidebar :navItems="nav" />
      <main class="main bg-gray-50">
        <VueSlickCarousel v-if="announcement.length" :arrows="false" :dots="true" :autoplay="false" :autoplaySpeed="4000"
          :infinite="true" :slidesToShow="1" :slidesToScroll="1" class="mb-0  custom-dots px-4 mx-0 mt-4">
          <div v-for="item in announcement" :key="item.id">
            <div class="bg-blue-50 text-blue-800 w-full h-custom px-3 py-3 rounded-md">
              <div class="flex justify-start w-full">
                <div class="mr-2">
                  <svg class="w-6 h-6 text-blue-800 dark:text-white" aria-hidden="true"
                    xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24">
                    <path fill-rule="evenodd"
                      d="M2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12Zm9.408-5.5a1 1 0 1 0 0 2h.01a1 1 0 1 0 0-2h-.01ZM10 10a1 1 0 1 0 0 2h1v3h-1a1 1 0 1 0 0 2h4a1 1 0 1 0 0-2h-1v-4a1 1 0 0 0-1-1h-2Z"
                      clip-rule="evenodd" />
                  </svg>
                </div>
                <div class="content-announcement">
                  <p class="font-semibold mb-1">
                    {{ item.title }}
                  </p>
                  <p style="
 
">
  {{ item.message }}
</p>
                </div>
              </div>

            </div>
          </div>
        </VueSlickCarousel>
        <div class="container-fluid">
          <router-view></router-view>
        </div>
      </main>
    </div>
    <AppFooter />
  </div>
</template>
<script>
import Http from "../plugins/http"
import AppHeader from "../components/Header/Header";
import Sidebar from "../components/Sidebar/Sidebar";
import AppFooter from "../components/Footer";
import VueSlickCarousel from 'vue-slick-carousel';
export default {
  name: "full",
  components: {
    AppHeader,
    Sidebar,
    AppFooter,
    VueSlickCarousel
  },
  data() {
    return {
      nav: [],
      announcement: [],
    };
  },
  mounted() {
    this.actionGetMenu()
    this.fetchAnnouncementsActive()
  },
  computed: {
    
    name() {
      return this.$route.name;
    },
    list() {
      return this.$route.matched;
    }
  },
  methods: {
    actionGetMenu(){
      
      Http.get('/menu').then(response => {
        this.nav = response.data.data.menu;
      })
        .catch(error => {
          console.log(error)
        })
    },

    fetchAnnouncementsActive() {
      Http.get('/active-announcement/').then(response => {
        this.announcement = response.data.data.rows;
      })
        .catch(error => {
          console.log(error)
        })
    }
  }
};
</script>
<style scoped>
@import url("../assets/css/bootstrap.min.css");
@import url("../assets/css/style.css");
@import url("../assets/fontawesome-6/css/all.min.css");

.app {
  font-family:"Avenir Next" ,"effra", Helvetica, Arial, sans-serif;
}

.custom-dots :deep(.slick-dots) {
  bottom: 60px;
  position: relative;
  left: 48%;
}

.custom-dots :deep(.slick-dots li) {
  margin: 0 2px;
  width: 8px;
}

.custom-dots :deep(.slick-dots li button) {
  width: 8px;
  height: 8px;
  padding: 0;
  border-radius: 50%;
  background: #C3DDFD;
}

.custom-dots :deep(.slick-dots li button:before) {
  content: '';
  opacity: 0;
}
.h-custom {
  height: 80px;
}
.custom-dots {
  height: 90px;
}
.custom-dots :deep(.slick-dots li.slick-active button) {
  background: #1E429F;
  /* Warna biru yang sesuai dengan tema Anda */
}
.content-announcement {
  font-size: 12px;
  margin-bottom: 12px;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: normal;
  line-height: 1.4em;
  width: 95%;
}
</style>
